import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import { AppIcon } from "../AppIcon";
import Box from "../Box";
import Button from "../Button";
import type { Milestone } from "./types";

export const MILESTONE_DOT_SIZE = 28;

type Props = {
	milestone: Milestone;
};

export const MilestoneItem = ({ milestone }: Props) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();
	const isCompleted = milestone.status === "completed";
	const isInProgress = milestone.status === "in-progress";
	const isLocked = milestone.status === "locked";
	const action = isMobile ? undefined : milestone.action;

	return (
		<Box flexDirection="row" alignItems="flex-start" gap={24}>
			<Box
				height={MILESTONE_DOT_SIZE}
				width={MILESTONE_DOT_SIZE}
				borderRadius={theme.roundness * 100}
				backgroundColor={
					isCompleted
						? theme.colors.primary
						: isInProgress
							? theme.colors.secondaryContainer
							: theme.colors.surfaceVariant
				}
				alignItems="center"
				justifyContent="center"
				style={{
					borderColor: theme.colors.surface,
					borderWidth: 2,
				}}
			>
				{isCompleted ? (
					<AppIcon name="check" size={14} color={theme.colors.onPrimary} />
				) : null}
				{isInProgress ? (
					<Box
						height={10}
						width={10}
						borderRadius={theme.roundness * 100}
						backgroundColor={theme.colors.secondary}
					/>
				) : null}
				{isLocked ? (
					<AppIcon
						name="lock-outline"
						size={18}
						color={theme.colors.onSurfaceVariant}
					/>
				) : null}
			</Box>
			<Box flex={1} gap={8}>
				<Text variant="bodyLarge">{milestone.title}</Text>
				<Text
					variant="bodyMedium"
					style={{ color: theme.colors.onSurfaceVariant }}
				>
					{milestone.description}
				</Text>
			</Box>
			{action ? (
				<Button
					mode="contained"
					onPress={action.onPress}
					style={{ alignSelf: "center" }}
				>
					{action.label}
				</Button>
			) : null}
		</Box>
	);
};
